import DraftSourceNotice from './DraftSourceNotice';
export default function DeclarationReconciliation({sources,declaration}:{sources:any;declaration:any}) {
 const audit=sources?.reconciliation;
 if(!audit)return null;
 const money=(value:number|null,currency:string)=>value==null?'Non renseigné':`${value.toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})} ${currency}`;
 return <section aria-label="Contrôle des sources historiques">
  <h4>Contrôle des sources historiques</h4>
  <DraftSourceNotice review={audit.source_review}/>
  {audit.unresolved>0&&<p role="status">{audit.unresolved} séjour(s) nécessitent un contrôle. Les données historiques sont incomplètes : un montant à zéro ne signifie pas une absence d’activité. Contactez l’ONT pour régulariser les sources.</p>}
  <p>Les calculs actuels ne remplacent pas les montants déjà validés.</p>
  {audit.totals?.map((row:any)=>{
   const declared=declaration[row.currency==='USD'?'declared_usd':'declared_cdf'];
   const due=typeof declared==='number'&&typeof declaration.fpt_rate==='number'?Math.round(declared*declaration.fpt_rate*100)/100:null;
   return <p key={row.currency}>CA enregistré : {money(row.recorded_revenue,row.currency)} · Base taxable actuelle : {money(row.taxable_base,row.currency)} · FPT calculée : {money(row.estimated_fpt,row.currency)} · FPT déclarée : {money(due,row.currency)} · Écart : {money(due==null?null:due-row.estimated_fpt,row.currency)}</p>;
  })}
 </section>;
}
